<template>
	<profile :profileData="profileData" />
</template>

<script>
import Profile from "@/components/profile/Profile";
import axios from "axios";

export default {
	components: { Profile },

	data() {
		return {
			profileData: "",
			userID: "",
		};
	},

	methods: {
		async getProfileData() {
			await axios
				.get(`users/profile/${this.userID}`)
				.then((response) => {
					this.profileData = response.data.data;
				})
				.catch((error) => {
					console.log("GET PROFILE DATA ERROR", error);
				});
		},
	},

	watch: {
		$route() {
			this.userID = this.$route.params.userID;
			this.getProfileData();
		},
	},

	created() {
		this.userID = this.$route.params.userID;
		this.getProfileData();
	},
};
</script>
